module.exports = __webpack_public_path__ + "static/media/BrunchFall24.42d05666.pdf";